import { UserLangCode } from "src/utils/util.types";
import { StatisticsType } from "../types/statistics.entity";
import { BaseStatAggregator } from "./base/base-stat-aggregator";
import { loungeRepository } from "src/features/lounge/lounge.repository";
import { Timestamp } from "firebase/firestore";
import { DateUtils } from "src/utils/date.util";

export class LoungeRequestStatsAggregator extends BaseStatAggregator {
  protected execQuery(statType: StatisticsType, langCode?: UserLangCode): Promise<number> {
    if (statType == "LAST_MONTH_LOUNGE_REQUESTS")
      return loungeRepository.count({
        createdAt: {
          $gte: Timestamp.fromDate(DateUtils.subtract(new Date(), 30, "day").toJSDate()),
        },
        langCode,
      });
    else return loungeRepository.count({ langCode });
  }
}
